import React from 'react';
import {formatPhoneNumber, formatNumber, formatDate, formatAgentPercent, percent} from "../../utils";
import PropTypes from "prop-types";

require('./Input.scss');

const Input = ({theme = 'default', value, valueType = 'text', label, handleParentChange, decimals = 2, style, viewMode = false, deleted = false, className = "", isDollar, ...rest}) => {
    const formatValue = (value, type) => {
        switch (type) {
            case 'number':
            case 'percent':
                return formatNumber(value);
            case 'integer': // price - with commas
            case 'float':   // price - with commas and decimals
                return formatNumber(value, true);
            case 'phone':
                return formatPhoneNumber(value);
            case 'date':
                return formatDate(value);
            case 'agent-percent':
                return formatAgentPercent(value);
            default:
                return value;
        }
    };

    const formatViewValue = () => {
        if (!value) return '-';
        switch (valueType) {
            case 'number':
                return formatNumber(value);
            case 'integer':
                return isDollar ? `$${value}` : value;
            case 'float':
                return isDollar ? `$${value}` : value;
            case 'phone':
                return formatPhoneNumber(value);
            case 'date':
                return formatDate(value);
            case 'percent':
            case 'agent-percent':
                return percent(value);
            default:
                return value;
        }
    };

    const handleChange = (e) => {
        const key = e.currentTarget.name;
        const value = formatValue(e.currentTarget.value, valueType);
        handleParentChange(key, value);
        return value;
    };

    const disabled = rest.disabled;
    const isPercent = valueType === 'percent';
    const agentPercent = valueType === 'agent-percent';
    const val = formatValue(value, valueType);
    const viewVal = formatViewValue();
    if (valueType === 'email') rest.type = 'email';

    return (
        <div className={`input-container ${theme}${agentPercent ? ' agent-percent' : ''} ${className}`}>
            {
                !agentPercent &&
                <label className={`input-label ${theme}${disabled ? ' disabled': ''}`}>{label}</label>
            }
            {
                !viewMode &&
                <div className='input-wrapper'>
                    <input className={`input ${theme}${disabled ? ' disabled' : ''}${isPercent ? ' percent' : ''}${agentPercent ? ' agent-percent' : ''}`}
                           style={style}
                           value={val || ''}
                           onChange={handleChange}
                           {...rest}
                    />
                    {
                        (isPercent || agentPercent) &&
                        <React.Fragment>
                            {
                                agentPercent &&
                                <span className={`percentage${!value ? ' no-value' : ''}`}>%</span>
                            }
                            <div className={`input-display-value${disabled ? ' disabled' : ''}${isPercent ? ' percent' : ''}${agentPercent ? ' agent-percent' : ''}${!value ? ' no-value' : ''}`}>
                                {value ? Number(value).toFixed(2) : ''}
                            </div>
                        </React.Fragment>
                    }
                </div>
            }
            {
                viewMode &&
                <div className={`view ${theme}${disabled ? ' disabled': ''}${deleted ? ' input-view-mode-deleted' : ''}`}>
                    {viewVal}
                </div>
            }
        </div>
    )
};

Input.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueType: PropTypes.oneOf(['text', 'number', 'integer', 'float', 'phone', 'email', 'date', 'percent', 'agent-percent']),
    label: PropTypes.string,
    handleParentChange: PropTypes.func,
    decimals: PropTypes.number,
    style: PropTypes.object,
    viewMode: PropTypes.bool,
    disabled: PropTypes.bool,
    deleted: PropTypes.bool,
    className: PropTypes.string,
};

export default Input;